import { Routes } from '@angular/router';
import { newUserRoutes } from 'app/core/routes/new-user-routes';

export const coreRoutes: Routes = [
  ...newUserRoutes
];
